import React from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const bootstrap = getBootstrap();
const bootstrapCsrfToken = bootstrap.get('csrfToken');

export const CsrfTokenContext = React.createContext(bootstrapCsrfToken);

export function withCsrfToken(Component) {
    return function ComponentWithCsrfToken(props) {
        return (
            <CsrfTokenContext.Consumer>
                {(csrfToken) => <Component {...props} csrfToken={csrfToken} />}
            </CsrfTokenContext.Consumer>
        );
    };
}

export const useCsrfToken = () => React.useContext(CsrfTokenContext);
